export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-camera-d41eeed38d3a0279d5e2ab930fe5a0dd.svg";